var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServicios(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#6E6259",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7 7v4h7V7H7zm5.808 2.745H8.192v-1.49h4.616v1.49zM9 14H12V15H9zM7 14H8V15H7zM13 14H14V15H13z",
    transform: "translate(-20 -516) translate(20 516)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 10.224c0-2.73-1.092-5.298-3.075-7.23C15.94 1.065 13.305 0 10.5 0 7.695 0 5.059 1.064 3.075 2.995 1.092 4.925 0 7.493 0 10.225c0 3.617 1.958 6.95 5.136 8.79L4.55 21h1.314l.097-.328h9.076l.097.328h1.314l-.585-1.985c3.178-1.84 5.136-5.173 5.136-8.79zM6.325 19.441l.267-.906h7.816l.267.906h-8.35zm.63-2.137l.242-.826h6.605l.244.826H6.954zm7.105-2.056H6.94c-.624 0-1.132-.494-1.132-1.102V7.198c0-.608.508-1.103 1.132-1.103h7.12c.624 0 1.132.495 1.132 1.103v6.948c0 .608-.508 1.102-1.132 1.102zm1.442 2.538l-.447-1.52c.825-.368 1.4-1.18 1.4-2.12V7.198c0-1.287-1.074-2.333-2.395-2.333H6.94c-1.32 0-2.396 1.046-2.396 2.333v6.948c0 .94.576 1.752 1.401 2.12l-.447 1.52c-2.628-1.65-4.234-4.489-4.234-7.562 0-4.959 4.143-8.994 9.236-8.994 5.093 0 9.236 4.035 9.236 8.994 0 3.073-1.606 5.913-4.234 7.562z",
    transform: "translate(-20 -516) translate(20 516)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicios);
export default __webpack_public_path__ + "static/media/servicios.116bc353.svg";
export { ForwardRef as ReactComponent };